import { createContext } from "react";
import { IAcademicYear, IAcademicYearForm } from "../types/academicYear.interface";
import { TModal } from "../types/common.type";

// ? Screen-scoped context for the academic-year management screen. Distinct from AcademicYear.context.ts, which
// ? holds the panel-wide *selected* year and is mounted by components/Layout.
export interface IAcademicYearScreenContext {
  isLoading      ?: boolean;
  showModal      ?: TModal;
  academicYears  ?: IAcademicYear[];
  selectedYear   ?: IAcademicYear;

  setShowModal   ?: (modal: TModal) => void;
  setSelectedYear?: (academicYear: IAcademicYear) => void;

  createFunction ?: (values: IAcademicYearForm) => Promise<void>;
  updateFunction ?: (values: IAcademicYearForm) => Promise<void>;
  deleteFunction ?: () => Promise<void>;
}

const AcademicYearScreen = createContext<IAcademicYearScreenContext>({});

export default AcademicYearScreen;
